import { queryOptions, useQuery } from "@tanstack/react-query";
import { createContext, use } from "react";
import { api, type AppConfig } from "./api.ts";

export const configQueryKey = ["config"] as const;

export const configQuery = queryOptions({
  queryKey: configQueryKey,
  queryFn: () => api<AppConfig>("/config"),
});

export function useConfigQuery() {
  return useQuery(configQuery);
}

export const ConfigContext = createContext<AppConfig | null>(null);

export function useConfig(): AppConfig {
  const config = use(ConfigContext);
  if (!config) throw new Error("useConfig outside ConfigContext");
  return config;
}
